import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import CustomSnackbar from "../../admin/components/CustomSnackbar";
import KeywordBox from "../../admin/components/KeywordBox";
import CrmTabs from "../../admin/crm/CrmTabs";
import ContactCardDialog from "./ContactCardDialog";
import ContactService from "./ContactService";
import { getColumns } from "./getColumns";

export default function ContactMain() {
    const [pageModel, setPageModel] = useState({ page: 0, pageSize: 25 });
    const [sort, setSort] = useState([{ field: "createdAt", sort: "desc" }]);
    const [rowCount, setRowCount] = useState(0);
    const [rows, setRows] = useState([]);
    const [keyword, setKeyword] = useState();
    const [selectionId, setSelectionId] = useState();

    const [openCard, setOpenCard] = useState(false);
    const [reload, setReload] = useState();

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severity, setSeverity] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        ContactService.requestList(pageModel, sort, setRows, setRowCount, keyword);
    }, [pageModel, sort, keyword, reload]);

    const handleCell = (cell) => {
        setSelectionId(cell.id);
        setOpenCard(true);
    };

    const handleSort = (model) => {
        setSort(model);
    };

    const handleSelectionModel = (model) => {
        setSelectionId(model.id);
    };

    const handleKeyword = (k) => {
        setKeyword(k);
    };

    const handleSnackBar = (severity, message) => {
        setOpenSnackbar(true);
        setSeverity(severity);
        setMessage(message);
    };

    return (
        <Box sx={{ flexGrow: 1, gap: 2, display: "flex", flexDirection: "column" }}>
            <CrmTabs />
            <Box sx={{ flexGrow: 1, gap: 2, display: "flex" }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <KeywordBox callback={handleKeyword} />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <DataGrid
                            rows={rows}
                            columns={getColumns()}
                            rowCount={rowCount}
                            pageSizeOptions={[25, 50, 100]}
                            paginationModel={pageModel}
                            onPaginationModelChange={(m) => setPageModel(m)}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                            paginationMode={"server"}
                            onCellClick={handleCell}
                            onSortModelChange={handleSort}
                            onSelectionModelChange={handleSelectionModel}
                            columnVisibilityModel={{ id: false }}
                            autoHeight={true}
                            hideFooterSelectedRowCount
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        id: false,
                                    },
                                },
                            }}
                        />
                    </Grid>
                </Grid>

                <CustomSnackbar open={openSnackbar} setOpen={setOpenSnackbar} severity={severity} message={message} />

                <ContactCardDialog
                    open={openCard}
                    setOpen={setOpenCard}
                    selectionId={selectionId}
                    callback={() => {
                        handleSnackBar("warning", "deleted");
                        setReload(moment());
                    }}
                />
            </Box>
        </Box>
    );
}
